import React from 'react';
import { RadioGroup, FormControlLabel, Radio, SxProps, Tooltip, Typography } from '@mui/material';

const UPGRADE_TYPE_OPTIONS = [
  { label: 'Regular Upgrade', value: 'regular', tooltip: 'Perform the Regular Upgrade for DBs (non-CDBs and CDBs).' },
  { label: 'Non-CDB to CDB Conversion', value: 'noncdb2cdb', tooltip: 'Upgrade will be performed along with the conversion from non-CDB to CDB, creating the database as a PDB in the target CDB.' },
  { label: 'PDB Relocation (Refreshable Clone)', value: 'pdbrelocation', tooltip: 'Upgrades and relocates the PDB using a refreshable clone to minimize downtime.' },
  { label: 'Unplug-Plug', value: 'unplugplug', tooltip: 'Unplugs the PDB from the Source CDB and Plugs into the Target CDB during Upgrade.' },
];

// Reusable radio group style for consistent spacing
export const radioGroupSx: SxProps = {
  '.MuiFormControlLabel-root': {
    mb: 1.5,
  },
};

interface UpgradeTypeProps {
  upgradeType: string;
  setUpgradeType: (v: string) => void;
}

const UpgradeType: React.FC<UpgradeTypeProps> = ({ upgradeType, setUpgradeType }) => (
  <RadioGroup
    value={upgradeType}
    onChange={e => setUpgradeType(e.target.value)}
    sx={radioGroupSx}
  >
    {UPGRADE_TYPE_OPTIONS.map(opt => (
      <FormControlLabel
        key={opt.value}
        value={opt.value}
        control={<Radio />}
        label={
          <Tooltip
            title={opt.tooltip}
            placement="right"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: theme => theme.palette.mode === 'dark' ? '#f5f5f5' : '#23272f',
                  color: theme => theme.palette.mode === 'dark' ? '#222' : '#fff',
                  fontSize: 15,
                  borderRadius: 2,
                  boxShadow: 3,
                  px: 2,
                  py: 1,
                  fontWeight: 400,
                  minWidth: 320,
                },
              },
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 16 }}>{opt.label}</Typography>
          </Tooltip>
        }
        sx={{ fontWeight: 600, fontSize: 16 }}
      />
    ))}
  </RadioGroup>
);

export default UpgradeType; 